'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = require('@liveauctioneers/react-intl');

exports.default = _reactIntl.FormattedMessage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Formatted/FormattedMessage.js
// module id = bhzT
// module chunks = 60